import { toast } from 'react-toastify';
import { postApiCall } from '../Handlers/HttpHandler';

/**
 * Fetches the list of casinos.
 */
export const getCasinos = async (token) => {
  try {
    const result = await postApiCall('casino-list', {}, token);
    if (result.error) {
      toast.error(result.error?.message ?? result.error);
      return null;
    }
    return result.data ?? [];
  } catch (ex) {
    toast.error('Failed to load casinos');
    return null;
  }
};
